const orderType = 'orderType',
  orderTypeDelivery =  'MENU_DEL',
  orderTypePickUp = 'MENU_TAK',
  orderTypeDineIn = 'MENU_DIN',
  deliveryAddress = 'deliveryAddress',
  deliveryTime = 'deliveryTime',
  skipFirstStep = 'skipFirstStep';

export {
  orderType as CONSTANT_ORDER_TYPE,
  orderTypeDelivery as CONSTANT_ORDER_TYPE_DELIVERY,
  orderTypePickUp as CONSTANT_ORDER_TYPE_PICKUP,
  orderTypeDineIn as CONSTANT_ORDER_TYPE_DINEIN,
  deliveryAddress as CONSTANT_DELIVERY_ADDRESS,
  deliveryTime as CONSTANT_DELIVERY_TIME,
  skipFirstStep as CONSTANT_SKIP_FIRST_STEP,
};